<template>
    <div class="faqs col-md-8 ml-sm-auto col-lg-9 px-4">
      <h1>ЧаВО</h1>
      <b-button-group class="head-group">
        <b-button variant="success" v-b-modal.modal-add-faq>Добавить</b-button>
      </b-button-group>
      <b-col lg="12" class="my-1">
        <b-form-group
          label="Фильтр"
          label-cols-sm="3"
          label-align-sm="right"
          label-size="sm"
          label-for="filterInput"
          class="mb-0"
        >
          <b-input-group size="sm">
            <b-form-input
              v-model="filter"
              type="search"
              id="filterInput"
              placeholder="Введите фразу/слово для поиска"
            ></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Очистить</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-table :filter="filter" striped hover :fields="fields" :items="items" table-variant="dark">
        <template v-slot:cell(id)="data">
          <b-button variant="success" @click="edit_item(data.value)" ref="btnEdit"><i class="fas fa-edit"></i></b-button>
          <b-button variant="secondary" @click="delete_item(data.value)"><i class="fas fa-trash-alt"></i></b-button>
        </template>
      </b-table>
      <modal-add @faqs="init"></modal-add>
      <modal-edit @faqs="init"></modal-edit>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import axios from 'axios';
import modalAdd from './ModalAdd';
import modalEdit from './ModalEdit';

export default {
  props: {
  },
  components: {
    'modal-add': modalAdd,
    'modal-edit': modalEdit,
  },
  data() {
    return {
      filter: null,
      fields: [
        { key: 'question', label: 'Вопрос', sortable: true },
        /*{ key: 'answer', label: 'Ответ', sortable: true },*/
        { key: 'tags', label: 'Тэги', sortable: true },
        { key: 'id', label: '', sortable: false }
      ],
    };
  },
  computed: {
    ...mapState({
      items: state => state.faq.items,
      host: state => state.host,
    }),
  },
  methods: {
    ...mapActions({
      initItems: 'faq/initItems', // -> this.initItems()
      initEditingItem: 'faq/initEditingItem', // -> this.initEditingItem()
      alertMsg: 'alertMsg', // -> this.alertMsg()
    }),
    init() {
      const path = this.host + 'faq';
      axios.post(path, {}, { headers: { Authorization: `Bearer ${localStorage.token}` } })
        .then((res) => {
          if (res.data.status === 'success') {
            this.initItems({
              items: res.data.faq
            })
          } else {
            this.alertMessage = `${res.data.status}: ${res.data.error}`;
            this.showAlert = true;
          }
        })
        .catch((error) => {
          // eslint-disable-next-line
          if (error.response.status === 401){
            this.$store.dispatch('init', { email: localStorage.email, id: '', token: '' });
            this.$router.push('/login');
          }
        });
    },
    delete_item(item_id) {
      const path = this.host + 'delete_faq';
      axios.post(path, {'id': item_id}, { headers: { Authorization: `Bearer ${localStorage.token}` } })
        .then((res) => {
          if (res.data.status === 'success') {
            this.init();
            this.alertMsg({
              alert: res.data.message,
              type: 'success',
            });
          } else {
            this.alertMsg({
              alert: res.data.error,
              type: 'danger',
            });
          }
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.log(error);
          if (error.response.status === 401){
            this.$router.push('/login');
          }
        });
    },
    edit_item(item_id) {
      this.initEditingItem({
        'index': item_id
      })
      this.$bvModal.show('modal-edit-faq');
    },
  },
  created() {
    this.init();
  },
};
</script>

<style>
  .head-group{
    margin-bottom: 15px;
  }
</style>
